import { getResourceAllocations } from "../../../actions/timesheet.action";
import moment from "moment";
import { updateProjectAction } from "../../../slice/project-detail";

export const getWorkAllocationsData = async ({ projectId, dispatch, timesheetData }) => {

    let timeSpentProgress = 0, timeAllocated = 0;
    let params = { projectId, updateTaskAllocation: true, };
    const resourceAllocations = timesheetData ? await timesheetData : await dispatch(getResourceAllocations(params));

    if (Array.isArray(resourceAllocations)) {
        resourceAllocations.forEach((item) => {
            const approvedStart = moment(item.approvedStartTime);
            const approvedEnd = moment(item.approvedEndTime);

            const _approvedHrs = moment.duration(approvedEnd.diff(approvedStart)).asHours();
            if (item.status === 'PENDING') {
                const allocatedStartTime = moment(item.startTime);
                const allocatedEndTime = moment(item.endTime);
                const allocatedHrs = moment.duration(allocatedEndTime.diff(allocatedStartTime)).asHours();
                timeAllocated += allocatedHrs;
            }
            if (item.status === 'APPROVED') {
                timeAllocated += _approvedHrs;
                timeSpentProgress += _approvedHrs;
            }
        });
    }

    // timeSpentProgress = Math.floor((timeSpentProgress / 1000 / 60 / 60) % 24);
    // timeSpentProgress = Math.floor((timeSpentProgress / 1000 / 60 / 60));
    timeAllocated = Math.floor(timeAllocated) + ":" + parseInt((timeAllocated * 60) % 60);
    timeSpentProgress = Math.floor(timeSpentProgress) + ":" + parseInt((timeSpentProgress * 60) % 60);
    dispatch(updateProjectAction({ timeSpentProgress }))
    return { timeSpentProgress, timeAllocated };

};